import React from 'react';
import apiData from 'Lib/apiData';
import Helmet from 'react-helmet';
import objectPath from 'object-path';
import AccountHero from '../components/account/account-hero';
import AccountImpact from '../components/account/account-impact';
import PublicAccountDetails from '../components/account/public-account-details';

export default class User extends React.PureComponent {

  static async getInitialProps({ query }) {
    const { id } = query;

    const user = await apiData(`/v1/users/${id}`);

    return { user, userId: id };
  }

  render() {
    const { user, userId } = this.props;
    const locality = objectPath.get(user, 'address.locality', '');
    const region = objectPath.get(user, 'address.region', '');
    const shareURL = `https://www.wavesforwater.org/users/${userId}`;

    return (
      <main>
        <Helmet title={`${user.firstName} ${user.lastName}`} />
        <AccountHero
          name={`${user.firstName} ${user.lastName}`}
          location={`${locality}${locality && region && ', '}${region}`}
          photo={user.profileImage}
          hideButtons
        />
        <AccountImpact
          totals={user.totals}
          shareURL={shareURL}
        />
        <PublicAccountDetails user={user} userId={userId} />
      </main>
    );
  }
}
